module.exports = __webpack_public_path__ + "static/media/decibel-knowledgebase-praise.3add1f36.md";